import { AxiosError } from 'axios';
import { toast } from 'react-toastify';

export const ServerErrorHandling = (err: AxiosError, isRefresh: any = false) => {
    const configure: any = {
        position: "bottom-center",
        rtl: true,
        autoClose: true,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
    }
    if (err.response) {
        switch (err.response.status) {
            case 401:
                toast.error(err.response.data?.detail, { ...configure });
                window.localStorage.clear();
                window.location.reload();
                break;
            case 403:
                toast.error(err.response.data?.detail, { ...configure });
                break;
            case 500:
                toast.error('مشکل سمت سرور', { ...configure });
                break;
            default:
                if (err.response.data?.detail) {
                    console.log('4', err.response.data.detail)
                    toast.error(err.response.data?.detail, { ...configure });
                } else if (err.response.data?.error) {
                    console.log('3', err.response.data.error)
                    toast.error(err.response.data?.error, { ...configure })
                } else if(err.response.data?.errors?.length){
                    err.response.data?.errors.map((error:any) => 
                        toast.error(error.detail, { ...configure })
                    )
                }else if(err.response.data?.data){
                    console.log(err.response.data?.data)
                    toast.error(err.response.data?.data, { ...configure })
                } else {
                    if (err.response.data?.length && typeof err.response.data !== 'string') {
                        console.log('2', err.response.data)
                        err.response.data.map((err: any) => {
                            toast.error(err, { ...configure });
                        })
                    } else {
                        console.log('1', JSON.stringify(err.response.data))
                        toast.error(JSON.stringify(err.response.data), { ...configure })
                    }
                }
        }
    } else {
        if (err.message === "Network Error")
            toast.info("مشکل اتصال به اینترنت");
    }
};
